import type { Dispatch, SetStateAction } from 'react'

import { Modal } from 'components'
import { useParams } from 'react-router-dom'

import ModalTrackingOrder from './ModalTrackingOrder'
import ModalTrackingOV from './ModalTrackingOV'
import * as S from './styles'

export interface PropsModal {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

const ModalTracking = ({ open, setOpen }: PropsModal) => {
  const { ovNumber, orderNumber } = useParams()

  const isOrder = !!orderNumber
  const title = isOrder ? `pedido: #${orderNumber}` : `OV: #${ovNumber}`
  const subTitle = isOrder ? 'neste pedido' : 'nesta Ordem de Venda'

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Modal
      closeAction={handleClose}
      open={open}
      setOpen={setOpen}
      showAction={false}
      title={`Tracking ${title}`}
    >
      <S.Content>
        <S.DescriptionWrapper>
          {`Acompanhe aqui todas as atualizações realizadas ${subTitle}.`}
        </S.DescriptionWrapper>

        {isOrder && open ? <ModalTrackingOrder /> : <ModalTrackingOV />}
      </S.Content>
    </Modal>
  )
}

export default ModalTracking
